import { Anchor, Breadcrumbs, useMantineTheme, Text, createStyles, ScrollArea } from "@mantine/core"
import { CurrentLocale } from "../App"
import { GetTranslated, TranslateField } from "../types/translate-field"

const useStyles = createStyles((theme) => ({
    otherItems: {
        color: theme.colors.hkc[0],
        padding: 10,
        '&:hover': {
            fontWeight: 500,
            paddingBottom: 5,
            borderBottom: `5px solid ${theme.colors.hkc[1]}`,
            textDecoration: 'none'
        }
    }
}))
export interface NavBarItem {
    title: TranslateField
    slug: string
    catId?: number | undefined
}

const NavBar = (props: { navTree: NavBarItem[]}) => {
    const locale = CurrentLocale
    const theme = useMantineTheme()
    const { classes } = useStyles()
    const items = props.navTree.map((itm, idx, a) => (
        idx != a.length - 1 ?
            <Anchor href={itm.slug} key={idx} className={classes.otherItems}>
                {GetTranslated(itm.title, locale)}
            </Anchor>
            :
            <Text style={{ fontWeight: 500, color: theme.colors.hkc[2], padding: 15 }}>
                {GetTranslated(itm.title, locale)}
            </Text>

    ))
    return (
        <ScrollArea style={{width: '100%'}}>
            <div style={{ width: '100%', height: 'auto', padding: '0px 20px', backgroundColor: theme.colors.offWhite[0] }}>
                <Breadcrumbs>{items}</Breadcrumbs>
            </div>
        </ScrollArea>
    )

}

export default NavBar